import { Controller } from "@hotwired/stimulus";

// PDF viewer controller with Safari compatibility
export default class extends Controller {
  static targets = ["iframe"];

  connect() {
    // Add error handling for iframe loading
    this.iframeTarget.addEventListener("load", this.handleLoad.bind(this));
    this.iframeTarget.addEventListener("error", this.handleError.bind(this));

    // Set a timeout to detect if PDF fails to load
    this.loadTimeout = setTimeout(() => {
      this.checkIfPdfLoaded();
    }, 3000);
  }

  disconnect() {
    if (this.loadTimeout) {
      clearTimeout(this.loadTimeout);
    }
  }

  handleLoad() {
    if (this.loadTimeout) {
      clearTimeout(this.loadTimeout);
    }
  }

  handleError() {
    console.warn("PDF failed to load in iframe");
    this.showFallback();
  }

  checkIfPdfLoaded() {
    try {
      // Try to access iframe content to check if PDF loaded
      const iframeDoc =
        this.iframeTarget.contentDocument ||
        this.iframeTarget.contentWindow.document;
      if (!iframeDoc || iframeDoc.body.innerHTML.trim() === "") {
        this.showFallback();
      }
    } catch (error) {
      // Cross-origin or other error - assume it's working
      console.log("Cannot check iframe content (likely cross-origin)");
    }
  }

  showFallback() {
    // Create fallback content
    const fallback = document.createElement("div");
    fallback.className =
      "h-full flex flex-col items-center justify-center p-8 bg-base-100";
    fallback.innerHTML = `
      <div class="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8 text-primary">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c0 .621-.504 1.125-1.125 1.125V11.25a9 9 0 0 0-9-9Z" />
        </svg>
      </div>
      <h4 class="text-lg font-semibold text-base-content mb-2">PDF non supporté</h4>
      <p class="text-base-content/70 text-center mb-4">Votre navigateur ne peut pas afficher ce PDF</p>
      <a href="${this.iframeTarget.src}" 
         target="_blank" 
         class="btn btn-primary btn-sm">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 mr-2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
        </svg>
        Télécharger le PDF
      </a>
    `;

    // Replace iframe with fallback
    this.iframeTarget.parentNode.replaceChild(fallback, this.iframeTarget);
  }
}
